import { generateSparkline } from '../../utils/chartGenerators'

interface SparklineProps {
  points?: number
  height?: number
  data?: number[]
}

export function Sparkline(props: SparklineProps) {
  const { points = 60, height = 120, data } = props
  if (data && data.length > 1) {
    const width = data.length - 1
    const max = Math.max(...data)
    const min = Math.min(...data)
    const range = max - min || 1
    const coordinates = data.map((value, index) => ({
      x: (index / width) * 120,
      y: height - ((value - min) / range) * height
    }))
    const pointsAttr = coordinates.map(({x, y}) => `${x.toFixed(1)},${y.toFixed(1)}`).join(' ')
    const path = coordinates.map(({x, y}, i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ')

    return (
      <svg viewBox={`0 0 120 ${height}`} className="w-full h-[140px]">
        <polyline fill="none" stroke="#2ee6a2" strokeWidth="2" points={pointsAttr}/>
        <path d={`${path} L 120,${height} L 0,${height} Z`} fill="rgba(64,231,162,0.06)"/>
      </svg>
    )
  }

  const d = generateSparkline(points, height)
  const path = d.x.map((x, i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${d.y[i].toFixed(1)}`).join(' ')

  return (
    <svg viewBox={`0 0 ${d.w} ${height}`} className="w-full h-[140px]">
      <polyline
        fill="none"
        stroke="#2ee6a2"
        strokeWidth="2"
        points={d.x.map((x, i) => `${x},${d.y[i]}`).join(' ')}
      />
      <path
        d={`${path} L ${d.w},${height} L 0,${height} Z`}
        fill="rgba(64,231,162,0.06)"
      />
    </svg>
  )
}
